import {DG_axios} from "../../../../custom/axios";
import jwtDecode from "jwt-decode";
import {DG_axiosNormal} from "../../../../custom/axios/normal";
import {store} from "../../../../redux/store/store";
import {logoutStart} from "../../../../redux/actions/login/actions";

const baseUrl = "/dogoo/account-rest/v2.0"

export const getAllAccounts = async (filter, page, pageSize, search, sort) => {
    const response = await DG_axios.get(baseUrl + "/accounts", {
        params: {
            filter,
            page,
            pageSize,
            search,
            sort
        }
    })
    return response?.data || []
}

export const changePassword = async (accountId, params) => {
    const response = await DG_axios.put(`${baseUrl}/accounts/${accountId}/update-password`, params)
    return response?.data || []
}
export const changeEmail = async (accountId, params) => {
    const response = await DG_axios.put(`${baseUrl}/accounts/${accountId}/update-email`, params)
    return response?.data || []
}

export const getAvatarByAccountId = async (accountId) => {
    const response = await DG_axiosNormal.get(`${baseUrl}/accounts/${accountId}/avatar`)
    return response?.data || []
}


export const getMe = () => {
    try {
        const accessToken = localStorage.getItem("accessToken");
        return jwtDecode(accessToken);
    } catch (e) {
        store.dispatch(logoutStart())
    }
}

export const getMeLogin = () => {
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken){
        return jwtDecode(accessToken);
    }

    return undefined
}
